module.exports = __webpack_public_path__ + "static/media/008.28be9407.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/thumbs/008.jpg
// module id = 515
// module chunks = 0